import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Facebook, Instagram, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-dark text-white pt-16 pb-8 border-t-4 border-light-blue" data-id="element-51" data-mp="3ghc3u5juj9pt">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-52" data-mp="32pfg0dp7nlz8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-53" data-mp="36oo8lf8ildt7">
          {/* Company Info */}
          <div data-id="element-54" data-mp="3ugbshd7czolz">
            <img src="https://cdn.magicpatterns.com/uploads/5AVKXiTXV1VVA3kGuFBhc2/TheSoftwashPros-logo.jpg" alt="Softwash Pros Logo" className="h-16 bg-white rounded p-1 mb-6" data-id="element-55" data-mp="3ufjyu7xbo0yc" />
            <p className="text-gray-400 mb-6" data-id="element-56" data-mp="3qdf5796vj4bp">
              Professional soft washing and exterior cleaning services. We
              restore your property's beauty safely and effectively.
            </p>
            <div className="flex space-x-4" data-id="element-57" data-mp="2ey08m6ikueh4">
              <a href="#" className="w-10 h-10 rounded-full bg-navy flex items-center justify-center hover:bg-light-blue hover:text-dark transition-colors" data-id="element-58" data-mp="2ez1k2c3i92zd">
                <Facebook className="w-5 h-5" data-id="element-59" data-mp="3gc0ffejw1k4z" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-navy flex items-center justify-center hover:bg-light-blue hover:text-dark transition-colors" data-id="element-60" data-mp="3v89fgibls1ig">
                <Instagram className="w-5 h-5" data-id="element-61" data-mp="828ly3a19z83" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-62" data-mp="33e5h7zjgmr5">
            <h4 className="text-xl font-montserrat font-bold mb-6 text-white" data-id="element-63" data-mp="31uqrltj6jrh">
              Quick Links
            </h4>
            <ul className="space-y-3" data-id="element-64" data-mp="ctqm4p48fvs0">
              <li data-id="element-65" data-mp="cus1h5sa74fj">
                <Link to="/" className="text-gray-400 hover:text-light-blue transition-colors" data-id="element-66" data-mp="cu8qk911tgb0">
                  Home
                </Link>
              </li>
              <li data-id="element-67" data-mp="mptptzeqg2h2">
                <Link to="/about" className="text-gray-400 hover:text-light-blue transition-colors" data-id="element-68" data-mp="tv4n215bx24h">
                  About Us
                </Link>
              </li>
              <li data-id="element-69" data-mp="13sr2qpugcxpi">
                <Link to="/services" className="text-gray-400 hover:text-light-blue transition-colors" data-id="element-70" data-mp="13s98tzv9ivkr">
                  Our Services
                </Link>
              </li>
              {/* <li>
               <Link
               to="/gallery"
               className="text-gray-400 hover:text-light-blue transition-colors"
               >
               Before & After Gallery
               </Link>
               </li> */}
              <li data-id="element-71" data-mp="1rj4zuurw9mqy">
                <Link to="/contact" className="text-gray-400 hover:text-light-blue transition-colors" data-id="element-72" data-mp="1rhk5b55ky3t3">
                  Contact / Free Quote
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-73" data-mp="2afx2n01a495z">
            <h4 className="text-xl font-montserrat font-bold mb-6 text-white" data-id="element-74" data-mp="2agop9lcwewk4">
              Our Services
            </h4>
            <ul className="space-y-3" data-id="element-75" data-mp="25mkess4fc6ea">
              <li data-id="element-76" data-mp="21m0jlu3evcus">
                <Link to="/services/residential" className="text-gray-400 hover:text-light-blue transition-colors" data-id="element-77" data-mp="21nlexlxjuztp">
                  Residential Soft Washing
                </Link>
              </li>
              <li data-id="element-78" data-mp="2pcea3g6cl3n9">
                <Link to="/services/roof" className="text-gray-400 hover:text-light-blue transition-colors" data-id="element-79" data-mp="2pc4l9vx1h2j5">
                  Roof Cleaning
                </Link>
              </li>
              <li data-id="element-80" data-mp="2fdoqniyszb4w">
                <Link to="/services/gutter" className="text-gray-400 hover:text-light-blue transition-colors" data-id="element-81" data-mp="2fgazdlxfjwop">
                  Gutter Cleaning
                </Link>
              </li>
              <li data-id="element-82" data-mp="2rv7onw1tdw09">
                <Link to="/services/driveway" className="text-gray-400 hover:text-light-blue transition-colors" data-id="element-83" data-mp="2ruofb3q8cfxu">
                  Driveway & Concrete
                </Link>
              </li>
              <li data-id="element-84" data-mp="2it88f5ymivyd">
                <Link to="/services/deck" className="text-gray-400 hover:text-light-blue transition-colors" data-id="element-85" data-mp="2ntw78dt3gh35">
                  Deck & Patio Cleaning
                </Link>
              </li>
              <li data-id="element-86" data-mp="3fk0m5wy34bwz">
                <Link to="/commercial" className="text-gray-400 hover:text-light-blue transition-colors" data-id="element-87" data-mp="3fj7qps4kt8u5">
                  Commercial Soft Washing
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-88" data-mp="1q8gpnqcbne5g">
            <h4 className="text-xl font-montserrat font-bold mb-6 text-white" data-id="element-89" data-mp="1v5gww4kwqmy5">
              Contact Us
            </h4>
            <ul className="space-y-4" data-id="element-90" data-mp="1nlfyxkh81qsb">
              <li className="flex items-start" data-id="element-91" data-mp="1nkedcm2kxlwc">
                <Phone className="w-5 h-5 text-light-blue mr-3 mt-1 shrink-0" data-id="element-92" data-mp="1in4op8n0le9k" />
                <div data-id="element-93" data-mp="1ip7i82ndlpj1">
                  <span className="block text-sm text-gray-400" data-id="element-94" data-mp="1wn5sowykt1t9">
                    Call for a Free Quote
                  </span>
                  <a href="tel:586-298-2727" className="text-lg font-bold hover:text-light-blue transition-colors" data-id="element-95" data-mp="1roug4egwcd7c">
                    586-298-2727
                  </a>
                </div>
              </li>
              <li className="flex items-start" data-id="element-96" data-mp="1dobdjmv79zck">
                <Mail className="w-5 h-5 text-light-blue mr-3 mt-1 shrink-0" data-id="element-97" data-mp="1dp2ym3r68eol" />
                <div data-id="element-98" data-mp="18w9t3dnvp2bg">
                  <span className="block text-sm text-gray-400" data-id="element-99" data-mp="18vqhsfsqhc6e">Email Us</span>
                  <a href="mailto:SoftwashPros@gmail.com" className="hover:text-light-blue transition-colors" data-id="element-100" data-mp="l65yfvso4cwl">
                    SoftwashPros@gmail.com
                  </a>
                </div>
              </li>
              <li className="flex items-start" data-id="element-101" data-mp="2l8yh09jd5rgw">
                <MapPin className="w-5 h-5 text-light-blue mr-3 mt-1 shrink-0" data-id="element-102" data-mp="2l7ndmattylqb" />
                <div data-id="element-103" data-mp="2q0yocn1rjmni">
                  <span className="block text-sm text-gray-400" data-id="element-104" data-mp="2q2sz58jblydv">
                    Service Area
                  </span>
                  <span className="text-gray-300" data-id="element-105" data-mp="1xc18eql0y1xx">
                    Proudly serving the local area and surrounding communities.
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-106" data-mp="2795wwx2ce9hw">
          <p className="text-gray-500 text-sm mb-4 md:mb-0" data-id="element-107" data-mp="2bd3sixsgl267">
            &copy; {new Date().getFullYear()} Softwash Pros. All Rights
            Reserved.
          </p>
          <div className="flex space-x-4 text-sm text-gray-500" data-id="element-108" data-mp="3mpxvfyqm2ie4">
            <Link to="#" className="hover:text-white transition-colors" data-id="element-109" data-mp="1b3cj6ceizi7y">
              Privacy Policy
            </Link>
            <span data-id="element-110" data-mp="1718xyw220z9h">|</span>
            <Link to="#" className="hover:text-white transition-colors" data-id="element-111" data-mp="17322a4p737eb">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}